import BordOneToneIcon from 'components/NudosComponents/BordOneToneIcon/BordOneToneIcon';
import './QuoteConfirmationModalHeader.scss';

interface IQuoteConfirmationModalHeader {
  onClose: () => void;
}

/** Encabezado del modal de confirmación de envío de cotización: título, subtítulo y botón de cierre. */
const QuoteConfirmationModalHeader = ({ onClose }: IQuoteConfirmationModalHeader) => (
  <div className="quoteConfirmationModalHeader">
    <div className="quoteConfirmationHeaderText">
      <div className="quoteConfirmationHeaderTitle">Enviar cotización al cliente</div>
      <div className="quoteConfirmationHeaderSubtitle">Revisa el resumen antes de confirmar el envío de la cotización.</div>
    </div>
    <button className="closeBtn" onClick={onClose}>
      <BordOneToneIcon variant="x" standardSize={24} />
    </button>
  </div>
);

export default QuoteConfirmationModalHeader;
